import {registerRoute as workbox_routing_registerRoute} from '/Users/anzhiyu/Project/anzhiyu`blog/node_modules/workbox-routing/registerRoute.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/Users/anzhiyu/Project/anzhiyu`blog/node_modules/workbox-strategies/CacheFirst.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/Users/anzhiyu/Project/anzhiyu`blog/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheableResponsePlugin as workbox_cacheable_response_CacheableResponsePlugin} from '/Users/anzhiyu/Project/anzhiyu`blog/node_modules/workbox-cacheable-response/CacheableResponsePlugin.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/Users/anzhiyu/Project/anzhiyu`blog/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/anzhiyu/Project/anzhiyu`blog/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/anzhiyu/Project/anzhiyu`blog/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "404.html",
    "revision": "aa83f20182757ef3f21d122f9cf64595"
  },
  {
    "url": "css/index.css",
    "revision": "a6a7cc39ebabdfa75ccebf8186cb4d16"
  },
  {
    "url": "/",
    "revision": "index-20230722075446463"
  }
], {});




workbox_routing_registerRoute(/^https:\/\/npm\.elemecdn\.com\/anzhiyu-blog/, new workbox_strategies_CacheFirst(), 'GET');
workbox_routing_registerRoute(/^https:\/\/index\.anheyu\.com\/*/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"anzhiyu-index", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 20, maxAgeSeconds: 2592000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 200 ] })] }), 'GET');
workbox_routing_registerRoute(/(.*?)\.html.*/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"anzhiyu-html", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 20, maxAgeSeconds: 2592000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 200 ] })] }), 'GET');
workbox_routing_registerRoute(/(.*?)\.(png|jpe?g|svg|webp|gif|bmp|psd|tiff|tga|ico|eps)/, new workbox_strategies_CacheFirst({ "cacheName":"anzhiyu-images", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 30 })] }), 'GET');
workbox_routing_registerRoute(/(.*?)\.js.*/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"anzhiyu-js", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 30, maxAgeSeconds: 2592000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 200 ] })] }), 'GET');
workbox_routing_registerRoute(/(.*?)\.css.*/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"anzhiyu-css", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 20, maxAgeSeconds: 2592000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 200 ] })] }), 'GET');




